export default "__VITE_ASSET__CcuM_hZb__"